var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertSyncIcon = function SvgAlertSyncIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M3 7.999h1.363c0-.716.175-1.418.506-2.033a3.8 3.8 0 0 1 1.375-1.469 3.4 3.4 0 0 1 1.862-.495 3.4 3.4 0 0 1 1.833.614l-.664.73a2.51 2.51 0 0 0-2.32-.119c-.33.151-.63.372-.884.65-.254.279-.455.61-.592.974a3.3 3.3 0 0 0-.208 1.148h1.366L4.817 10zm7.374 1.476c.23-.45.352-.96.352-1.476H9.363L11.18 6 13 7.999h-1.363c0 .715-.173 1.418-.504 2.035a3.8 3.8 0 0 1-1.375 1.47 3.37 3.37 0 0 1-1.864.494 3.4 3.4 0 0 1-1.833-.617l.664-.73a2.52 2.52 0 0 0 2.682-.082 2.9 2.9 0 0 0 .967-1.094",
    clipRule: "evenodd"
  })));
};
export { SvgAlertSyncIcon as ReactComponent };